import type { CertificateFormat } from "../../../hooks/use-certificates";

export const formatOptions: { value: CertificateFormat; label: string }[] = [
  { value: "certificate", label: "Standard Certificate" },
  { value: "certificate-extended", label: "Extended Certificate" },
  { value: "calculations", label: "Calculations Printout" },
  { value: "report-residential", label: "Residential Report" },
  { value: "report-commercial", label: "Commercial Report" },
  { value: "report-mixed-use", label: "Mixed Use Report" },
];

export function defaultFormatForCategory(category: string | null): CertificateFormat {
  switch (category) {
    case "STANDARD_COMMERCIAL":
      return "report-commercial";
    case "MIXED_USE":
      return "report-mixed-use";
    case "RESIDENTIAL":
    case "STANDARD_RESIDENTIAL":
    case "HIGH_END_RESIDENTIAL":
      return "report-residential";
    default:
      return "certificate";
  }
}

export function formatLabel(value: CertificateFormat): string {
  return formatOptions.find((o) => o.value === value)?.label ?? value;
}
